<script>
  import { format } from 'svelte-i18n';
  import { useNavigate } from 'svelte-navigator';
  import { Button, Modal } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';
  import { getNotificationsContext } from '@client/components/notifications';

  import { PluginsService } from '@client/services/plugins';

  import { IntegrationDetailsForm } from '../shared';

  const { addNotification } = getNotificationsContext();

  const navigate = useNavigate();

  export let data = {};
  export let show = false;
  export let showPreviousModal = false;
  export let fallbacktext = '';
  export let parameters = [];
  export let provider = '';
  export let rulename = '';

  let currentRulenames = [];

  const getCurrentRulenames = () => {
    data.forEach((plugin) => {
      currentRulenames.push(plugin.rulename);
    });

    return currentRulenames;
  };

  const notify = (text, type = 'success', autohide = 2500, position = 'top-right') => {
    addNotification({ text, type, autohide, position });
  };

  const onClose = () => {
    fallbacktext = '';
    parameters = [];
    provider = '';
    rulename = '';

    show = false;
  };

  const onKeyUp = (event) => {
    if (event.key === 'Escape') {
      onClose();
    }
  };

  const onGoBack = () => {
    onClose();

    setTimeout(() => (showPreviousModal = true), 200);
  };

  const onCreateIntegration = async () => {
    const data = {
      defaulttext: fallbacktext,
      params: parameters,
      provider: provider,
      rulename: rulename,
      status: true
    };

    const response = await PluginsService.savePlugin(data);

    if (response?.status >= 400) {
      notify($format('label.FAILURE.CREATE', { values: { type: rulename } }), 'error');

      return;
    }

    setTimeout(() => (show = false), 200);

    notify($format('label.SUCCESS.CREATE', { values: { type: rulename } }));

    navigate(`/manage/integrations/${rulename}`);
  };
</script>

<Modal bind:isOpen={show} close={false} size="lg" on:open={getCurrentRulenames}>
  <div id="form-modal" class="integration-form-modal">
    <div class="modal-actions">
      <button class="back" on:click={onGoBack}>
        <Icon name="arrow-left" style="font-size: var(--font-size-xlarge)" />
        <span>{$format('label.BACK')}</span>
      </button>

      <button class="close" on:click={onClose}>
        <Icon name="x" />
      </button>
    </div>

    <IntegrationDetailsForm bind:provider bind:rulename bind:parameters bind:fallbacktext bind:currentRulenames />

    <div class="footer-actions">
      <Button
        color="primary"
        on:click={onCreateIntegration}
        disabled={currentRulenames.includes(rulename) || rulename.length < 3}
      >
        {$format('label.INTEGRATION_FORM_MODAL_CREATE_INTEGRATION')}
      </Button>
    </div>
  </div>
</Modal>

<svelte:window on:keyup={onKeyUp} />

<style lang="scss" src="./form.scss"></style>
